import { handleActions } from 'redux-actions';
import { setCurrentPatientId, setPatients, setPatientById } from './actions';
import { hashById } from '../../../util/helpers';

const defaultState = {
  currentPatientId: undefined,
  patients: {},
};

export const reducer = handleActions(
  {
    [setCurrentPatientId]: (state, action) => {
      const currentPatientId = action.payload;
      return {
        ...state,
        currentPatientId,
      };
    },
    [setPatients]: (state, action) => {
      const patients = action.payload;
      return {
        ...state,
        patients: hashById(patients),
      };
    },
    [setPatientById]: (state, action) => {
      const { id, patient } = action.payload;
      return {
        ...state,
        patients: {
          ...state.patients,
          [id]: patient,
        },
      };
    },
  },
  defaultState,
);

export default reducer;



// WEBPACK FOOTER //
// ./src/lib/dataLayer/patient/reducer.js